<template>
  <i v-if="isSeen !== 1"
     class="fas fa-check color__blue"></i>
</template>

<script>
  export default {
    name: "is-seen-tag",
    props: ["isSeen"]
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/common/is-seen-tag.vue